module.exports = __webpack_public_path__ + "img/sphere_icon_hexa.a7e7dac2.png";